import parseStrategyApi from './parseStrategyApi';
import checkingApi from './checkingApi';
import importApi from './importApi';

export default {
  ...parseStrategyApi,
  ...checkingApi,
  ...importApi,
};
